import {
  HTTP_AP_ListHPIOutcodeToRegionEntries_Request_Filter,
  HTTP_AP_ListHPIOutcodeToRegionEntries_Request_Sort,
} from '@api-new/propertyservice';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';

export interface OutcodeToRegionTableRowModel {
  outcode: string;
  region: string;
  hasActionInProgress: boolean;
  isRecentlySaved: boolean;
}

export const outcodeToRegionTableFilterDefaults: HTTP_AP_ListHPIOutcodeToRegionEntries_Request_Filter = {
  region: '',
  outcode: '',
};

export const outcodeToRegionTableRowDefinition: TableRowDefinitionModel<
  OutcodeToRegionTableRowModel,
  HTTP_AP_ListHPIOutcodeToRegionEntries_Request_Sort
>[] = [
  {
    columnLabel: 'Outcode',
    columnKey: 'outcode',
    sortKey: 'byOutcode',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '80px',
      max: '80px',
    },
  },
  {
    columnLabel: 'Region',
    columnKey: 'region',
    sortKey: 'byRegion',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '150px',
      max: '150px',
    },
  },
];
